<template>
    <div>
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 class="h2">Gestion des échanges</h1>
            <button class="btn btn-custom" @click="openDecipherModal"
                    title="Déchiffrer un message">
                Déchiffrer un message
            </button>
        </div>

        <div class="mb-3 background-alt parent">
            <div class="col-lg-12 mt-3 mb-3">
                <div class="row">
                    <span class="centerFilter">Filtrer : </span>
                    <button class="btn btn-info btnFilter" v-for="(filtre, index) in arrayFilter" v-show="filtre !== ''"
                            @click="deleteFilter(index)">
                        {{ filtre.label }} <i class="fas fa-times"></i>
                    </button>
                </div>

                <div class="row">
                    <div class="col-lg-4  pt-2 pb-2">
                        <date-picker ref="datePickerComponent"/>
                    </div>
                    <div class="col-lg-4  pt-2 pb-2">
                        <v-select class="select background-alt" :options="results" v-model="result"></v-select>
                    </div>
                    <div class="col-lg-4  pt-2 pb-2">
                        <v-select class="select background-alt" :options="methods" v-model="method"></v-select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-4 pt-2 pb-2">
                        <v-select class="select background-alt" :options="devices" v-model="device"></v-select>
                    </div>
                    <div class="col-lg-4 pt-2 pb-2">
                        <v-select class="select background-alt" :options="calledUrls" v-model="calledUrl"></v-select>
                    </div>
                    <div class="col-lg-4 row pl-0 ml-auto">
                        <div class="col-lg-6 pl-0 pt-2 pb-2">
                            <button class="btn btn-custom w-100" @click="filter" title="Rechercher">Rechercher</button>
                        </div>
                        <div class="col-lg-6 pl-0 pt-2 pb-2">
                            <button class="btn btn-custom w-100" @click="initFilter"
                                    title="Réinitialiser la recherche">
                                Réinitialiser
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-3">
            <div class="col-lg-12 background-alt">
                <vue-element-loading :active="isActiveChart" spinner="spinner" class="customLoader" color="#a3285e"/>

                <line-chart :chart-data="dataChart"
                            chartId="bar-chart-1"
                            :options="{responsive: true, maintainAspectRatio: false,beginAtZero: true}"
                ></line-chart>
            </div>
        </div>

        <div class="mb-3 background-alt">
            <div class="table-responsive">
                <vuetable ref="vuetable"
                          api-url="/api/logs/table"
                          :fields="fields"
                          pagination-path=""
                          :append-params="moreParams"
                          :http-options="{ headers: { 'Authorization': 'Bearer ' + api_token }}"
                          @vuetable:pagination-data="onPaginationData"
                          class="table"
                          no-data-template=""
                >

                    <div slot="gender-slot" slot-scope="props">
                        <button class="btn-custom btn" title="Afficher les détails"
                                @click="openModal(props.rowData.id)"><i class="fas fa-search"></i></button>
                    </div>
                </vuetable>
            </div>

            <div class="row col-lg-12 pr-0">
                <div class="mr-auto">
                    <vuetable-pagination-info ref="paginationInfo"
                                              class="alert alert-info tablePagination"
                                              info-template="Affichage de {from} à {to} sur {total} logs"
                                              no-data-template="Aucun log"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                                         @vuetable-pagination:change-page="onChangePage"
                                         :css="css.pagination"
                    ></vuetable-pagination>
                </div>
            </div>
        </div>

        <modal :showModal="showModal" :hideModal="hideModal" :openModal="openModal">
            <h5 slot="header">
                Détail de l'échange
            </h5>

            <span slot="body" class="w-100">
                <div><b>Données reçues :</b></div>
                <div class="divDisplay"><pre>{{ modal.input_data}}</pre></div>

                <div><b>Données envoyées : </b></div>
                <div class="divDisplay"><pre>{{ modal.output_data}}</pre></div>
            </span>

            <span slot="footer">
                <button class="btn btn-danger" @click="hideModal">Fermer </button>
            </span>
        </modal>

        <modal :showModal="showDecipherModal" :hideModal="closeDecipherModal">

            <h5 slot="header">
                Déchiffrer un message
            </h5>

            <div slot="body" class="w-100">

                <div class="form-group">
                    <label for="toDecipherTextarea"><b>Message à déchiffrer :</b></label>
                    <textarea
                            id="toDecipherTextarea"
                            class="form-control"
                            rows="6"
                            v-model="messageToDecipher"
                    />
                </div>

                <div class="form-group d-flex justify-content-center pt-1">
                    <button class="btn btn-custom" @click="decipher">Déchiffrer</button>
                </div>

                <div class="form-group">
                    <label for="decipheredTextarea"><b>Message déchiffré : </b></label>
                    <textarea
                            id="decipheredTextarea"
                            class="form-control"
                            rows="6"
                            v-model="decipheredMessage"
                    />
                </div>

            </div>

            <span slot="footer">
                <button class="btn btn-danger" @click="closeDecipherModal">Fermer</button>
            </span>
        </modal>

        <infringement-search-result-modal></infringement-search-result-modal>

    </div>
</template>

<script>

    import moment from 'moment';
    import DatePicker from './layout/DateRangePicker';
    import vSelect from 'vue-select';
    import Vuetable from 'vuetable-2';
    import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
    import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo';
    import LineChart from './layout/LineChart';
    import Modal from './layout/Modal';
    import Vue from 'vue';
    import axios from 'axios';
    import VueElementLoading from 'vue-element-loading';
    import InfringementSearchResultModal from "./layout/InfringementSearchResultModal";

    export default {
        components: {
            LineChart,
            Vuetable,
            VuetablePagination,
            VuetablePaginationInfo,
            Modal,
            vSelect,
            DatePicker,
            VueElementLoading,
            InfringementSearchResultModal
        },
        data() {
            return {
                dataChart: {},
                moreParams: {},
                showModal: false,
                showDecipherModal: false,
                dateDefine: '',
                isActiveChart: true,
                modal: {
                    output_data: '',
                    input_data: ''
                },

                methods: [],
                results: [],
                devices: [],
                calledUrls: [],

                method: '',
                result: '',
                dateStart: '',
                dateEnd: '',
                device: '',
                calledUrl: '',

                arrayFilter: {
                    date: '',
                    method: '',
                    result: '',
                    device: '',
                    calledUrl: '',
                },

                messageToDecipher: '',
                decipheredMessage: '',

                fields: [
                    {
                        name: 'date_connect',
                        title: 'Date'
                    },
                    {
                        name: 'method',
                        title: 'Méthode'
                    },
                    {
                        name: 'url_called',
                        title: 'URL appelée'
                    },
                    {
                        name: 'result',
                        title: 'Résultat'
                    },
                    {
                        name: 'device.single_key',
                        title: 'PDA'
                    },
                    {
                        name: 'gender-slot',
                        title: '',
                    },
                ],

                css: {
                    pagination: {
                        activeClass: 'btn-custom',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                            first: '',
                            prev: '',
                            next: '',
                            last: '',
                        }
                    }
                }
            }
        },
        computed: {
            api_token() {
                return api_token;
            }
        },
        watch: {
            method: function () {
                if (this.method.id) {
                    this.arrayFilter.method = this.method;
                }
            },
            result: function () {
                if (this.result.id) {
                    this.arrayFilter.result = this.result;
                }
            },
            device: function () {
                if (this.device.id) {
                    this.arrayFilter.device = this.device;
                }
            },
            calledUrl: function () {
                if (this.calledUrl.id) {
                    this.arrayFilter.calledUrl = this.calledUrl;
                }
            }
        },
        created() {
            axios.get('/api/parameters/value?key=web.dashboard.log.period')
                .then(result => {
                    this.dateDefine = result.data;
                    this.dateStart = moment().subtract(this.dateDefine - 1, 'd').format('YYYY-MM-DD');
                    this.dateEnd = moment().format('YYYY-MM-DD');
                    this.initFilter();
                });

            this.$on('show-modal', (e) => {
                this.openModal(e.data.id)
            });
        },
        methods: {
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData);
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },

            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },

            getDevices() {
                this.devices = [];
                this.device = {id: '', imei: '', label: 'Terminal'};
                this.arrayFilter.device = '';
                axios.get('/api/repositories/device')
                    .then(result => {
                        let arrayDevice = _.orderBy(result.data.data, 'single_key', 'asc');
                        _.forEach(arrayDevice, value => {
                            this.devices.push(
                                {
                                    id: value.id,
                                    imei: value.imei,
                                    label: value.single_key.toString(),
                                }
                            );
                        })
                    })
            },

            getResults() {
                let i = 1;
                this.result = {id: '', label: 'Résultat'};
                this.results = [];
                this.arrayFilter.result = '';
                axios.get('/api/logs/filters/result')
                    .then(result => {
                        let arrayResult = _.orderBy(result.data, 'result', 'asc');
                        _.forEach(arrayResult, value => {
                            this.results.push(
                                {
                                    id: i,
                                    label: value.result.toString(),
                                }
                            );
                            i += 1;
                        });
                    })
            },

            getMethods() {
                let i = 1;
                this.methods = [];
                this.method = {id: '', label: 'Méthode'};
                this.arrayFilter.method = '';
                axios.get('/api/logs/filters/method')
                    .then(result => {
                        let arrayMethod = _.orderBy(result.data, 'method', 'asc');
                        _.forEach(arrayMethod, value => {
                            this.methods.push(
                                {
                                    id: i,
                                    label: value.method,
                                }
                            );
                            i += 1;
                        });
                    })
            },

            getCalledUrls() {
                this.calledUrl = {id: '', label: 'URL appelée', url: ''};
                this.calledUrls = [
                    {id: 1, label: 'Sessions', url: '/api/sessions'},
                    {id: 2, label: 'Controls', url: '/api/controls'},
                    {id: 3, label: 'IFs', url: '/api/ifs'},
                    {id: 4, label: 'Devices', url: '/api/devices'},
                    {id: 5, label: 'Fines', url: '/api/fines'},
                    {id: 6, label: 'Mercies', url: '/api/mercies'}
                ];
                this.arrayFilter.calledUrl = '';
            },

            getDate(start, end, date) {
                this.arrayFilter.date = {id: 1, label: date};
                this.dateStart = start;
                this.dateEnd = end;
            },

            initData() {
                this.arrayFilter.date = '';
                this.dateStart = moment().subtract(this.dateDefine - 1, 'd').format('YYYY-MM-DD');
                this.dateEnd = moment().format('YYYY-MM-DD');
                this.$refs.datePickerComponent.range = {
                    startDate: new Date(moment().subtract(this.dateDefine - 2, 'd').format('YYYY-MM-DD')),
                    endDate: new Date(moment().add(1, 'd').format('YYYY-MM-DD'))
                };
            },

            initFilter() {
                this.getDevices();
                this.getResults();
                this.getMethods();
                this.getCalledUrls();
                this.initData();
                this.filter();
            },

            deleteFilter(index) {
                //Allow to reinitialize each filter
                this.arrayFilter[index] = '';

                switch (index) {
                    case 'result':
                        this.result = {id: '', label: 'Résultat'};
                        this.arrayFilter.result = '';
                        break;
                    case 'method':
                        this.method = {id: '', label: 'Méthode'};
                        this.arrayFilter.method = '';
                        break;
                    case 'device':
                        this.device = {id: '', value: '', label: 'Terminal'};
                        this.arrayFilter.device = '';
                        break;
                    case 'calledUrl':
                        this.calledUrl = {id: '', label: 'URL appelée', url: ''};
                        this.arrayFilter.calledUrl = '';
                        break;
                    case 'date':
                        this.arrayFilter.date = '';
                        this.dateStart = moment().subtract(this.dateDefine - 1, 'd').format('YYYY-MM-DD');
                        this.dateEnd = moment().format('YYYY-MM-DD');
                        this.$refs.datePickerComponent.range = {
                            startDate: new Date(moment().subtract(this.dateDefine - 2, 'd').format('YYYY-MM-DD')),
                            endDate: new Date(moment().add(1, 'd').format('YYYY-MM-DD'))
                        };
                        break;
                }
            },

            filter() {
                this.isActiveChart = true;
                this.updateVueTable();
                this.updateGraphic();
            },

            updateGraphic() {
                axios.get('/api/logs/graph?method=' + this.method.label + '&result=' + this.result.label + "&start="
                    + this.dateStart + "&end=" + this.dateEnd + "&device=" + this.device.imei + "&url_called=" + this.calledUrl.url)
                    .then(result => {
                        let dataChart = {
                            labels: [],
                            datasets: [
                                {
                                    label: 'Nombre d\'échanges',
                                    backgroundColor: "rgba(30, 132, 73, 0.3)",
                                    data: []
                                }
                            ]
                        };
                        _.forEach(result.data, value => {
                            if (this.dateStart === this.dateEnd) {
                                dataChart.labels.push(moment(value.name.date).format('HH') + 'h');
                                dataChart.datasets[0].data.push(value.value);
                            } else {
                                dataChart.labels.push(moment(value.name.date).format('DD/MM/YYYY'));
                                dataChart.datasets[0].data.push(value.value);
                            }
                        });
                        this.dataChart = dataChart;
                        this.isActiveChart = false;
                    });
            },

            updateVueTable() {
                this.moreParams = {
                    'method': this.method.label,
                    'result': this.result.label,
                    'url_called': this.calledUrl.url,
                    'start': this.dateStart,
                    'end': this.dateEnd,
                    'device': this.device.imei
                };
                Vue.nextTick(() => this.$refs.vuetable.refresh());
            },

            openModal(id) {
                axios.get('/api/connects/' + id)
                    .then(result => {
                        let input_data = JSON.stringify(JSON.parse(result.data.input_data), null, 2);
                        let output_data = JSON.stringify(JSON.parse(result.data.output_data), null, 2);

                        this.modal = {
                            input_data: input_data,
                            output_data: output_data,
                        }
                    });
                this.showModal = true;
            },

            hideModal() {
                this.showModal = false;
            },

            openDecipherModal() {
                this.showDecipherModal = true;
            },

            closeDecipherModal() {
                this.showDecipherModal = false;
            },

            decipher() {
                axios.post('/api/logs/decipher',{messageToDecipher: this.messageToDecipher})
                    .then(result => {
                        this.decipheredMessage = result.data;
                    });
            }
        },
    }
</script>

<style>
    .divDisplay {
        overflow: scroll;
        height: 200px;
        background-color: rgba(211, 211, 211, 0.5);
        color: black;
    }

    pre {
        overflow: initial;
    }

    .customLoader {
        z-index: 0 !important;
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/Log.vue